import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  badge: {
    width: 34,
    height: 34,
    borderRadius: 8,
    backgroundColor: '#E1251B',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFFFF',
    flexShrink: 0,
    boxShadow: '0 2px 4px rgba(225, 37, 27, 0.25)',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.badge}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
      </svg>
    </div>
  );
};

export default LogoIcon;
